var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0","scrolling":"no","allow":"autoplay","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }